import { Button, Col, Form, Input, Modal, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { selectTime } from "../../utils/helper/constants";
import { formatDateFunction, formatDateFunctionNew } from "../../utils/helper/utils";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";
import toast from "react-hot-toast";
import ConfirmationModal from "../../Modal/ConfirmationModal";
const daysName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const BranchAddSlot = ({ isOpen, onOk, onCancel, selectedDate, data, onSubmit, slotFor = "branch" }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  let { branchId } = useParams(); //id,

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [itemData, setItemData] = useState(false);

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };
  const handleSubmit = async () => {
    try {
      // Validate and get the form values
      const values = await form.validateFields();
      let slotId = data ? data?.id : 0;
      values.date = selectedDate;

      values.api_type = "edit";

      if (values.openTime && values.closeTime && values.closeTime <= values.openTime) {
        form.setFields([
          {
            name: "closeTime",
            errors: ["Please select correct time."],
          },
        ]);
        return false;
      }

      // Call the external submit handler
      if (onSubmit) {
        let date = new Date(values.date);
        let day = daysName[date.getDay()].toLowerCase();

        let insertData = {
          type: data?.type,
          day: day,
          date: formatDateFunction(date, "yyyy-mm-dd"), //"2024-11-24",
          openTime: values.openTime,
          closeTime: values.closeTime,
          capacity: values.capacity,
          id: slotId,
          api_type: "edit",
        };

        if (slotFor === "fastest_branch") {
          insertData.branchId = branchId;
        } else {
          insertData.typeId = branchId;
          insertData.slotFor = slotFor;
        }

        dispatch(changeLoader(true));
        try {
          let url = slotFor === "fastest_branch"
            ? (slotId && slotId > 0 ? Apis?.FASTEST_TIME_SLOTE?.UPDATE_DATE_SLOT : Apis?.FASTEST_TIME_SLOTE?.CREATE_DATE_SLOT)
            : (slotId && slotId > 0 ? Apis?.TIME_SLOTE?.UPDATE_DATE_SLOT : Apis?.TIME_SLOTE?.CREATE_DATE_SLOT);
          let method = "post";
          if (slotId && slotId > 0) {
            method = "put";
          }
          let response = await globalRequest(url, method, insertData, {}, true);
          let apiResponse = response?.data;
          if (response?.status === 200) {
            let msg = "Slot created successfully";
            if (slotId) msg = "Slot updated successfully";
            toast.success(msg, {
              duration: 2000,
            });
            onSubmit();
            form.resetFields();
            onOk();
          } else {
            toast.error(apiResponse?.message);
          }
        } catch (e) {
          toast.error(e?.message);
        }
        dispatch(changeLoader(false));
      }
    } catch (error) {
      console.error("Form validation failed:", error);
    }
  };

  useEffect(() => {
    if (data) {
      form.setFieldValue("openTime", data?.openTime);
      form.setFieldValue("closeTime", data?.closeTime);
      form.setFieldValue("capacity", data?.capacity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = {
        id: data.id,
        api_type: "delete",
        status: "deleted",
        type: data.type,
        day: data.day,
        date: formatDateFunction(selectedDate, "yyyy-mm-dd"),
        openTime: "00:00:00",
        closeTime: "00:00:00",
      };
      if (slotFor === "fastest_branch") {
        value.branchId = branchId;
      } else {
        value.typeId = branchId;
        value.slotFor = slotFor;
      }
      let url = slotFor === "fastest_branch" ? Apis?.FASTEST_TIME_SLOTE?.UPDATE_DATE_SLOT : Apis?.TIME_SLOTE?.UPDATE_DATE_SLOT;
      let response = await globalRequest(url, "put", value, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Time slot deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });

        onSubmit();
        form.resetFields();
        onOk();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  return (
    <>
      <Modal
        title={data.id ? "Edit Slot" : "Add Slot"}
        centered
        open={isOpen}
        onCancel={onCancel}
        footer={
          <Row style={{ width: "100%" }}>
            <Col span={12} style={{ textAlign: "left" }}>
              {/* Delete will only show when the time slot is edited. */}
              {data.id ? (
                <div
                  className="text-red-700 font-semibold text-base mt-1 cursor-pointer"
                  onClick={() => {
                    // setItemData(data);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  Delete
                </div>
              ) : null}
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Button key="back" onClick={onCancel} className="mx-2.5 cursor-pointer">
                Cancel
              </Button>
              <Button key="save" type="primary" onClick={handleSubmit}>
                Save
              </Button>
            </Col>
          </Row>
        }
        okText="Save"
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <div className="text-lg mb-5 font-semibold">{formatDateFunctionNew(selectedDate)}</div>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Open Time"
                name="openTime"
                rules={[
                  {
                    required: true,
                    message: "Please Select Your Open Time.",
                  },
                ]}
              >
                <Select
                  size="large"
                  placeholder="Select"
                  options={selectTime}
                  showSearch
                  filterOption={(input, selectTime) => (selectTime?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  className="w-[200px]"
                  // value={data?.openTime || ""}
                  onChange={(date, dateString) => {
                    form.setFieldValue("openTime", date);
                    handleInputChange("openTime");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Close Time"
                name="closeTime"
                rules={[
                  {
                    required: true,
                    message: "Please Select Your Close Time.",
                  },
                ]}
              >
                <Select
                  size="large"
                  placeholder="Select"
                  options={selectTime}
                  showSearch
                  filterOption={(input, selectTime) => (selectTime?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  onChange={(value) => {
                    form.setFieldValue("closeTime", value);
                    handleInputChange("closeTime");
                  }}
                  className="w-[200px]"
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Capacity"
            name="capacity"
            rules={[
              {
                required: true,
                message: "Please enter your Capacity!",
              },
              {
                validator: (_, value) => {
                  if (value === 0 || (value && Number.isInteger(Number(value)) && value.toString().length <= 8)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Invalid capacity")); //Capacity must not exceed 8 digits!
                },
              },
            ]}
          >
            <Input size="large" min={0} type="number" />
          </Form.Item>
          <div className="text-sm mb-5 text-gray-150">
            You are editing this day's shifts only, To set regular shifts, go to {slotFor === "fastest_branch" ? "fastest working hours" : "working hours"}.
          </div>
        </Form>
      </Modal>
      {/* delete modal */}
      {isDeleteModalOpen && (
        <ConfirmationModal
          ConfirmationHeading="Delete"
          ConfirmationParagraph="Are you sure you want to delete this timeslot?"
          isOpen={isDeleteModalOpen}
          onOk={handleDeleteOk}
          onCancel={handleDeleteCancel}
        />
      )}
    </>
  );
};
export default BranchAddSlot;
